var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 500",
    style: {
      enableBackground: "new 0 0 700 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5FF"
    },
    cx: 380,
    cy: 218.053,
    rx: 232.754,
    ry: 165.915
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DFDFEB"
    },
    cx: 176.685,
    cy: 444.642,
    rx: 106.251,
    ry: 16.346
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DFDFEB"
    },
    cx: 350.35,
    cy: 447.912,
    rx: 191.948,
    ry: 16.346
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3DDF7"
    },
    d: "M298.132,44.938c-19.821,0.54-36.221,16.416-37.361,36.212c-0.671,11.64,3.84,22.232,11.432,29.705 c1.122,1.104,1.643,2.678,1.381,4.23l-2.851,16.871l17.542-10.221c0.999-0.582,2.176-0.796,3.31-0.567 c4.288,0.865,8.831,1.024,13.514,0.315c17.329-2.625,30.849-16.971,32.447-34.425C339.674,63.796,321.094,44.313,298.132,44.938z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M297.451,96.755l-0.108-9.205c1.343-0.327,2.568-0.753,3.676-1.28c1.107-0.526,2.079-1.134,2.914-1.825 c0.835-0.689,1.534-1.461,2.098-2.315c0.563-0.853,0.988-1.77,1.28-2.75c0.29-0.98,0.435-2.015,0.435-3.104 c0-1.561-0.382-3.032-1.145-4.412c-0.762-1.379-1.852-2.496-3.268-3.35c-1.416-0.853-3.105-1.28-5.065-1.28 c-2.106,0-4.058,0.581-5.855,1.743c-1.798,1.163-3.169,3.141-4.112,5.937l-0.98-0.654c0.835-2.65,2.233-4.684,4.194-6.1 c1.961-1.417,4.193-2.125,6.699-2.125c2.143,0,4.022,0.455,5.638,1.362c1.615,0.908,2.877,2.134,3.785,3.677 c0.907,1.543,1.362,3.277,1.362,5.202c0,1.453-0.245,2.814-0.735,4.085c-0.49,1.271-1.181,2.433-2.07,3.486 c-0.89,1.054-1.97,1.97-3.241,2.75c-1.272,0.782-2.705,1.371-4.303,1.771l-0.108,8.388H297.451z M296.798,103.618 c0-0.472,0.127-0.862,0.381-1.171c0.254-0.308,0.6-0.463,1.035-0.463c0.508,0,0.871,0.146,1.09,0.436 c0.218,0.291,0.326,0.69,0.326,1.198c0,0.436-0.118,0.817-0.354,1.144c-0.237,0.327-0.591,0.49-1.063,0.49 c-0.473,0-0.826-0.146-1.063-0.436S296.798,104.127,296.798,103.618z"
  })))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.716,421.638l1.708,12.873c0,0,32.021,13.64,29.051,13.837c-2.97,0.198-48.986-2.772-48.986-2.772l2.708-23.37 L186.716,421.638z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeMiterlimit: 10
    },
    d: "M177.796,211.483c0,0-2.552,24.56-4.465,25.836 c-1.914,1.276-4.465,1.914-4.465,1.914l4.146-28.068L177.796,211.483z"
  }), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.231,194.601c0,0-12.979,29.307-9.211,45.635l71.946-10.974l-1.501-30.446L127.231,194.601z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.966,229.263c0,0,0.407,70.315,0.907,94.813c0.5,24.498,4.784,100.154,4.784,100.154s-13.435,7.407-27.428,1.421 c-1.119-0.479-13.173-197.044-13.173-197.044L189.966,229.263z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.212,231.533L88.853,424.872c0,0,13.258,12.421,30.005,1.116l30.87-157.923L164.719,258l2.233-28.807 L119.212,231.533z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.24,420.086l2.764,11.106c0,0,20.201,24.296,17.224,24.296c-2.977,0-36.149-15.04-36.149-15.04l4.253-23.138 L111.24,420.086z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeMiterlimit: 10
    },
    d: "M130.301,206.464c0,0-19.132,80.438-33.354,222.455"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeMiterlimit: 10
    },
    d: "M143.42,215.116c0,0-6.699,16.747-18.143,17.026"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeMiterlimit: 10
    },
    points: "171.716,426.81 161.928,260.38 171.49,250.352  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EC68A"
    },
    d: "M171.588,110.399c4.978-1.019,8.611-1.75,8.611-1.75l31.048,16.957 c0.053,0.029,0.106,0.058,0.159,0.087c10.174,5.614,14.671,15.139,14.403,28.488l1.508,19.337l-16.825-13.653l-14.223,27.427 l-9.033,32.379c-48.204,17.529-66.928-13.943-66.928-13.943l15.971-34.573l6.451-31.93 C145.795,122.84,155.26,113.742,171.588,110.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M432.232,165.021c0,0-4.864,20.348-32.391,45.175c0,0-2.627-3.716,3.249-18.036 C408.968,177.841,431.079,159.944,432.232,165.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M432.232,165.021 c0,0-24.307,15.135-32.391,45.175c0,0-1.857,10.361,1.14,19.633"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M368.695,177.638c0,0,6.837-4.523-3.59-17.582c-9.905-12.406-20.513-23.64-42.317-28.905 c0,0,4.741,30.294,18.653,38.335C355.354,177.526,368.695,177.638,368.695,177.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M313.766,196.169c0,0,22.685,6.493,62.538-4.027c0,0-2.16-4.189-19.509-6.663 C339.447,183.005,309.439,192.526,313.766,196.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M313.766,196.169 c0,0,28.539-12.843,62.538-4.027c0,0,3.484,1.113,6.781,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M331.498,218.235c0,0,23.58,17.784,63.434,7.264c0,0-6.708-14.214-24.056-16.688 C353.527,206.337,327.172,214.592,331.498,218.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M331.498,218.235 c0,0,27.329-10.68,63.434,7.264c0,0,4.239,2.222,7.535,7.269"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M419.889,144.668c0,0,7.321-0.405-11.461,14.861c-17.735,14.414-15.614,14.672-15.614,14.672 S400.653,151.433,419.889,144.668z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M380.132,181.266c0,0,5.292,2.44,15.656-5.915c10.364-8.355,15.296-28.14,24.101-30.682 C419.889,144.668,397.849,150.26,380.132,181.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M411.312,252.328 c-9.614-22.946-23.323-49.193-42.616-74.69c0,0-4.69-7.034-21.365-25.557c-16.675-18.523-24.541-20.93-24.541-20.93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M417.271,145.571 c0,0-21.122,7.649-37.139,35.694c-3.88,6.794-0.132,12.608,2.952,17.036"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M631.119,409.856c0,0-20.485,6.148-54.668-16.004c0,0,2.245-5.951,17.706-6.909 C609.617,385.986,635.224,405.07,631.119,409.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M630.352,408.351 c0,0-22.503-17.707-53.501-15.085c0,0-10.375,1.779-18.073,7.753"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M586.53,364.197c0,0,6.58,4.89,15.312-9.358c8.295-13.535,15.249-27.333,12.781-49.628 c0,0-26.874,14.766-29.7,30.584C582.095,351.614,586.53,364.197,586.53,364.197z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M639.368,389.648c0,0,4.301,5.939-18.698-1.6c-21.717-7.118-20.786-5.196-20.786-5.196S623.273,377.128,639.368,389.648z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M587.081,376.007c0,0,0.81,5.771,13.444,9.968c12.634,4.197,31.942-2.358,38.843,3.673 C639.368,389.648,622.742,374.135,587.081,376.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M530.798,429.686 c18.305-16.849,38.321-38.67,55.732-65.489c0,0,5.018-6.804,16.762-28.787c11.744-21.983,11.33-30.199,11.33-30.199"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M637.192,387.934 c0,0-17.86-13.627-50.111-11.927c-7.813,0.412-11.352,4.216-17.209,11.521"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333969"
    },
    d: "M418.092,205.978c6.268,0,12.338-2.2,17.151-6.216l13.355-11.144 c4.806-4.01,10.514-6.159,16.363-6.159h66.278c6.014,0,10.89,4.876,10.89,10.89v12.628v227.316 c0,10.378-8.413,18.792-18.792,18.792H192.945c-8.072,0-14.616-6.544-14.616-14.616V220.594c0-8.072,6.544-14.616,14.616-14.616 H418.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7584F1"
    },
    d: "M178.33,438.694c0,0,22.485-42.177,24.734-47.021l61.451-125.192 c1.545-3.327,4.879-5.455,8.547-5.455H501.42c8.302,0,20.309-4.352,26.683-9.671l9.215-7.689 c4.806-4.01,10.515-6.159,16.363-6.159h63.074c6.714,0,11.274,6.82,8.709,13.025l-76.271,184.469 c-4.275,10.34-14.361,17.084-25.55,17.084H182.454c-2.224,0-4.278-1.905-4.277-4.129L178.33,438.694z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 271.214,
    y1: 272.93,
    x2: 181.042,
    y2: 448.217
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M308.37,303.137h77.675 c2.118,0,4.089-1.066,5.226-2.826l0,0c2.624-4.061-0.338-9.376-5.226-9.376H308.37c-2.118,0-4.089,1.066-5.226,2.825h0 C300.519,297.822,303.482,303.137,308.37,303.137z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 453.669,
    y1: 363.383,
    x2: 393.192,
    y2: 399.413
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 404.223,
    y1: 361.646,
    x2: 442.224,
    y2: 399.63
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9638 -0.2666 0.2666 0.9638 -86.2615 126.9009)",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 424.181,
    cy: 381.108,
    rx: 45.474,
    ry: 34.356
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EC68A"
    },
    d: "M193.761,192.146l11.215,12.594c0,0-10.521,12.414-21.207,5.061l-1.714-2.459L193.761,192.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M167.701,117.001 c0,0,15.366,4.026,3.276,48.447"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M194.702,193.467 c-8.296-9.321-18.436-21.033-24.426-29.108"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M183.769,209.801 c-7.962-8.163-18.721-19.782-23.417-24.088c-7.318-6.711-14.913-17.509-12.437-31.381l-0.297-11.122"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EC68A"
    },
    d: "M231.563,203.84c-9.805-5.298-14.322-11.857-18.103-16.719 c-9.02-11.597-12.216-13.033-9.573-26.531l0.145-14.126l19.569,21.178c7.473,9.913,24.701,27.684,31.066,34.686 C254.667,202.328,247.195,212.286,231.563,203.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M191.654,200.263c0.902-0.247,1.837-0.323,2.767-0.225c3.356,0.355,12.349,1.299,13.364,1.312 c1.25,0.016,2.266-1.85,4.948,4.915c2.682,6.764,2.201,7.394,2.185,8.278c-0.015,0.884-1.961,13.873-4.051,11.922 c-2.09-1.951-1.809-3.087-1.809-3.087s-1.127,5.275-1.72,5.072c-0.593-0.204-2.79-0.21-2.438-3.935c0,0-1.198,3.621-2.433,2.72 c-1.235-0.9-0.958-4.814-0.958-4.814s-1.322,2.938-2.832,0.977c-1.509-1.962-0.385-6.505-0.385-6.505l-1.265-3.376l-2.737-1.183 c0,0-9.213,2.41-10.798-3.985C182.275,203.435,188.641,201.087,191.654,200.263z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.185,208.555  211.915,215.825 209.058,223.378  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "205.744,208.286  207.985,215.737 204.899,224.514  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "201.848,209.118  203.153,216.282 201.66,221.648  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M194.324,70.995 c-3.269,3.06-3.317,6.781-3.317,6.781s-1.124-1.388-2.514-1.834"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M241.021,198.182c3.109-0.751,6.387-0.243,9.233,1.215c3.745,1.919,9.595,4.891,10.358,5.119 c1.133,0.338,1.872-0.275,2.022,6.606c0.059,2.719,0.051,4.596-0.191,5.397c-0.243,0.8-5.739,9.012-7.544,7.856 c-0.049-0.032-0.083-0.058-0.128-0.088c-0.458,0.615-1.071,1.369-1.673,1.883c-0.451,0.385-2.961,0.333-1.677-2.964 c0,0-1.74,3.811-3.093,3.303c-1.763-0.662-1.477-2.357-0.834-3.791c-0.819,1.106-1.833,2.007-2.554,1.05 c-1.415-1.878,1.79-8.557,1.79-8.557l0.374-4.045l-2.446-2.189c0,0-8.743,0.214-8.53-6.013 C236.225,200.107,238.541,198.781,241.021,198.182z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "260.208,208.602  260.097,215.98 254.715,223.811  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "256.387,208.66  255.966,216.265 251.421,223.205  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "252.507,208.859  251.962,215.263 248.083,221.697  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M241.444,207.152c0,0,0.878,6.601-1.253,8.05c-2.13,1.449-5.566-12.202-3.203-12.376 C240.451,202.57,241.444,207.152,241.444,207.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M244.348,206.198 c0,0-2.119,0.34-2.724,2.828"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M203.227,174.253l10.3-13.424 c9.416-12.457,3.141-25.626,3.141-25.626"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M227.318,173.518 c0,0-6.068-8.413-7.447-4.689"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 229.662,
    y1: 103.504,
    x2: 227.915,
    y2: 103.136
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M193.14,101.877l-12.941,6.772c0,0-0.34,15.358,14.193,27.031l6.526-6.341l6.577,6.579 c0,0,2.502-1.965,3.245-10.882l-1.173-10.826L193.14,101.877z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 209.568,114.21 193.14,101.877 180.199,108.649  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M189.383,104.206c0,0,4.001,23.394,9.925,25.052c5.923,1.657,9.618-10.041,9.618-10.041 l-11.47-31.934L189.383,104.206z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.126,122.03l0.071,2.908c0.054,0.03-0.118,0.898-3.002,1.229c-12.671-0.378-13.674-14.636-14.705-25.979 C193.49,100.189,212.296,119.766,211.126,122.03z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M228.858,90.226c0,0,3.255,29.652-14.139,34.47c-17.394,4.818-21.561-23.547-20.961-33.357 c0.6-9.81,5.498-14.655,17.689-15.094C229.482,75.595,228.858,90.226,228.858,90.226z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.818,82.189c0,0-0.326,6.232-4.462,7.477l-2.974,9.165c0,0-2.492-4.073-5.23-5.516c0,0-3.024-12.103,0.783-16.912 c3.807-4.809,9.099-7.247,21.902-6.182c9.745,0.81,15.446,7.723,17.308,11.24c0.604,1.14,2.069,4.344-1.356,7.461 c0,0,0.046-2.358-1.954-5.117C226.835,83.805,222.169,93.344,202.818,82.189"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M186.142,100.402c1.073,3.913,4.151,6.499,6.875,5.777s4.064-4.479,2.991-8.392 c-1.072-3.913-4.151-6.499-6.875-5.777C186.408,92.733,185.069,96.49,186.142,100.402z"
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M211.221,101.709c-0.05,1.008,0.429,1.851,1.07,1.884c0.641,0.033,1.2-0.758,1.249-1.766 c0.05-1.008-0.429-1.851-1.07-1.884C211.83,99.911,211.27,100.702,211.221,101.709z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M224.637,102.538c-0.099,0.944,0.288,1.76,0.864,1.821c0.576,0.061,1.124-0.654,1.223-1.599 c0.099-0.944-0.288-1.76-0.864-1.821C225.283,100.878,224.736,101.594,224.637,102.538z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M207.391,93.727 c0,0,4.607,0.987,4.914-3.382"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M223.002,93.369 c0,0,1.174,4.061,4.637,1.71"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M210.416,117.954c0,0-1.519-6.189-6.233-2.641L210.416,117.954z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M188.876,96.996 c0,0,3.064-2.636,4.738,2.184c0,0-1.79,1.9-0.66,3.391c0,0-1.765,0.4-2.635-1.156"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M190.203,98.84 c0,0,0.171-1.071,1.36-2.294"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M221.977,102.385c0,2.864,1.76,5.186,3.932,5.186 c2.172,0,3.932-2.322,3.932-5.186s-1.76-5.186-3.932-5.186C223.737,97.199,221.977,99.521,221.977,102.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M207.261,101.676c0,3.035,2.241,5.495,5.005,5.495 c2.764,0,5.005-2.46,5.005-5.495c0-3.035-2.241-5.495-5.005-5.495C209.502,96.18,207.261,98.641,207.261,101.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M222.154,103.886c0,0-1.217-5.165-5.165-0.366"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 207.366,
    y1: 99.596,
    x2: 195.735,
    y2: 96.976
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M222.641,106.171 c0.576,0.731,0.696,1.602,0.405,2.544c-0.287,0.93-1.235,1.496-2.195,1.476c-0.445-0.009-0.872-0.129-1.293-0.261 c-0.184-0.057-0.548-0.254-0.746-0.167c-0.959,0.424-2.076-0.413-1.756-1.067"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataNotFound);
export default __webpack_public_path__ + "static/media/data_not_found.f42c3adda1eaddca1330773a82885cd0.svg";
export { ForwardRef as ReactComponent };